import { useCreateSubscriptionCheckout } from '@/shared/api/generated/subscriptions';

export const useCreateCheckout = () => {
  return useCreateSubscriptionCheckout();
};
